import { RoutesStore } from "./store/routes.store.service";

export class RoutesService extends RoutesStore {}
